import React, { useState, useEffect } from "react";
import { MDBInput } from "mdb-react-ui-kit";
import logo from "../../assets/img/logo.png";
import LoadingScreen from "react-loading-screen";
import "react-responsive-pagination/themes/classic.css";
import { useHistory } from "react-router-dom";
import Select from "react-select";
// reactstrap components
import {
  Button,
  Card,
  CardBody,
  Row,
  Col,
} from "reactstrap";
import axios from "axios";
import {
    INSERT_PULSE,
    UPDATE_PULSE,
    FETCH_PULSE_ID,
  ALL_CLIENT_LIST
  
} from "../../constants";
import NotificationAlert from "react-notification-alert";



const initialState = {
  client: "",
  pulse: ""
};
let clientsList = [];
const CreatePulse = (props) => {

  const navigate = useHistory();
  const [isLoading, setIsLoading] = useState(true);
  const notificationAlertRef = React.useRef(null);
  const [pulsedata, setPulsedata] = useState(initialState);
  const [error, setError] = useState();



  useEffect(() => {
    getClients();
    props?.location?.state?.id && fetchPulseDtls(props?.location?.state?.id);
  }, []);


const getClients=async()=>{
    setIsLoading(true)
    clientsList = [];
    await axios.get(ALL_CLIENT_LIST).then(res=>{
      setIsLoading(false)
      res?.data?.data?.map(item=> clientsList.push({ value: item.id, label: item.company_name}))
    }).catch(err=>{
      let options = {};
      options = {
        place: "tr",
        message: "Unable fetch records",
        type: "warning",
        autoDismiss: 2,
      };
      notificationAlertRef.current.notificationAlert(options);
      setIsLoading(false)
    })
}

const fetchPulseDtls=(id)=>{
  axios.get(`${FETCH_PULSE_ID}?id=${id}`).then(res=>{
    setPulsedata({
      pulse:res?.data?.pulse,
      client:{ value: res?.data?.client_id, label: res?.data?.client_name}

    })
    
  }).catch(e=>{
    console.log("Exception==>",e);
  })
}


  const submitpulse = async() => {


 
    const isvalid = validate()
    
  setError(isvalid)
    if (Object?.keys(isvalid)?.length === 0) {
        let payload ={
            pulse:pulsedata?.pulse,
            client:pulsedata?.client?.value

        }
      if (props?.location?.state?.id) {
        
        payload={...payload,
            "id": props?.location?.state?.id.toString()
        }
        console.log(payload,"--95--");
       
       
       await axios
          .post(UPDATE_PULSE, payload)
          .then((response) => {

            let options = {};
            options = {
              place: "tr",
              message: "Updated Successfully",
              type: "success",

              autoDismiss: 2,
            };
            notificationAlertRef.current.notificationAlert(options);

            setTimeout(() => {
              navigate.push("/admin/configuration/pulse");
            }, 1000)
          })
          .catch((error) => {
            console.log("catch--", error);
          });
      } else {

        axios
          .post(INSERT_PULSE, payload)
          .then((response) => {
           
            let options = {};
            options = {
              place: "tr",
              message: "Saved Successfully",
              type: "success",

              autoDismiss: 5,
            };
            notificationAlertRef.current.notificationAlert(options);
            setTimeout(() => {
              navigate.push("/admin/configuration/pulse");
            }, 1000)


          })
          .catch((error) => {
            console.log("catch--", error);
          });

      }
    }
  };

  const validate = () => {
   
    let errors = {}
 
    if (!pulsedata?.pulse) {
      errors.pulse = "Pulse required"
    } 
    if (!pulsedata?.client) {
        errors.client = "Client required"
    } 
   
    return errors;
  }


  return (
    <>
      <LoadingScreen
          children=""
          loading={isLoading}
          bgColor="rgba(0,0,0,0.7)"
          spinnerColor="#9ee5f8"
          textColor="#676767"
          logoSrc={logo}
          text="Loading..."
        ></LoadingScreen>
      <div className="content pd-0">
        <Row>
          <Card className="mb-0">
            <NotificationAlert ref={notificationAlertRef} />
            <CardBody>
              <Row>
                <Row>
               
                  <Col sm="10">
                    <h4 className="mt-4 add-content" style={{ width: "200px" }} onClick={() => navigate.push("/admin/configuration/pulse")}>
                      <Button
                        className="btn btn-icon btn-link-add btn-sm mr-2"

                      >
                        <i class="fa fa-arrow-left" aria-hidden="true"></i>
                      </Button>
                      {props?.location?.state?.id ? "Update Pulse" : "Create Pulse"}
                    </h4>
                  </Col>
                </Row>
                <Col sm="3" className="mb-4">
                      <Select
                        className="react-select info"
                        classNamePrefix="react-select"
                        placeholder="Select Client"
                        name="client"
                        value={pulsedata?.client}
                        onChange={(value) => {
                          setPulsedata({...pulsedata,client:value});
                        }}
                        options={clientsList}
                      />
                      <span style={{color:"red"}}>{error?.client}</span>
                    </Col>
                <Col md="6" sm="8">
                  <Row>
                    <Col sm="4" className="mb-4">
                      <MDBInput
                        label="Pulse"
                        type="number"
                        name="pulse"
                        maxLength={100}
                        value={pulsedata?.pulse}
                        onChange={e => setPulsedata({...pulsedata,pulse:e.target.value})}
                      />
                      <span style={{ color: "red" }}>{error?.pulse}</span>
                    </Col>
                  </Row>
                </Col>

              </Row>
              <Row>
                <Col sm="12" className="">
                  <Button
                    type="submit"
                    className="btn btn-icon btn-primary mt-4 pull-right"
                    onClick={() => submitpulse()}
                  >
                    <i className="tim-icons icon-double-right"></i>
                  </Button>
                </Col>
              </Row>
            </CardBody>
          </Card>
        </Row>
      </div>
    </>
  );
};

export default CreatePulse;
